import React from "react";
import ResultFooterFree from "./ResultFooterFree";

export default class ResultFooter extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div aria-label='Resultate Footer' className='bg-blue-dark text-white'>
                <div className="md:container mx-auto xl:max-w-7xl">
                    <div className="container-inner">
                        <ResultFooterFree />
                    </div>
                </div>
            </div>
        )
    }
}
